/**
 * Message Component.
 * Author: @tejasupmanyu
 */
import { message as Message } from 'antd';
export default Message;
//# sourceMappingURL=message.js.map